// The rose press (R1758, ui-map-interface.md §12.0 and §17.3.03).
//
// A press on the compass rose centres the map on the hold. The rose is a
// picture on the canvas, so the press is a transparent DOM button over the
// rose's slot (§1, the canvas/DOM split): the overlay owns the button and
// the piece draws the answer on the rim. This module is the one wire
// between the two. The overlay counts a press here, and the piece reads the
// count on its next frame. It holds a count and not a time, because the
// piece reads the frame clock and the overlay has none.
//
// The rose is a visible control (R1802): a hover of the press lights a
// ring and the home glyph of the rose. The overlay writes the hover here
// on the pointer's enter and leave, and the piece reads it every frame.

import { esc } from './esc';

let presses = 0;
let hovered = false;

/** Counts one press of the rose press. The overlay calls it. */
export function noteRosePress(): void {
  presses++;
}

/** The presses so far. The compass rose reads it on every frame. */
export function rosePressCount(): number {
  return presses;
}

/** A pointer that can hover entered the rose press, or left it (R1802). */
export function noteRoseHover(on: boolean): void {
  hovered = on;
}

/** True while a hovering pointer stands on the rose press. */
export function roseHovered(): boolean {
  return hovered;
}

/**
 * The rose peek (R1802, card 16 of mockup round 086): the home icon, the
 * act and its key. It stands beside the round unit while a hovering
 * pointer is on the rose press; the stylesheet shows it, so it needs no
 * state of its own. `act` and `key` are the words; the caller reads them.
 */
export function rosePeekHtml(act: string, key: string): string {
  return '<svg class="mic" viewBox="0 0 24 24" aria-hidden="true">'
    + '<path d="M4 11.5L12 4l8 7.5"/><path d="M6.5 9.5V20h11V9.5"/></svg>'
    + `<b>${esc(act)}</b><span class="rp-key">${esc(key)}</span>`;
}
